import React, { useState } from "react";
import "./order-data-table.styles.scss";

import CustomButton from "../../commons/custom-button/custom-button.component";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import EmptyTableComponent from "../empty-component/empty-table-compontent";
import NumberFormat from "react-number-format";
import { ClientServices } from "../../../redux/clientdata/client.services";
import { getBRMSKey, getClientOrderHistory, getOldOrderHistory } from "../../../redux/clientdata/client.action";

function OrderDataTable({
    title,
    filterOne,
    filterTwo,
    tableItemsOne,
    tableItemsTwo,
    categoriesOne,
    categoriesTwo,
    tableOneColumnWidth = "210px",
    tableTwoColumnWidth = "210px",
}) {
    const [tableColumnWidth, setTableColumnWidth] = useState(tableOneColumnWidth);
    const [activeDisplay, setAtiveDisplay] = useState(filterOne);
    const [tableCategories, setTableCategories] = useState(categoriesOne);
    const [tableItems, setTableItems] = useState(tableItemsOne);
    const [showDataTable, setShowDataTable] = useState(false);

    const clientOrderHistoryList = useSelector(({ client }) => client.orderHistoryList);
    const oldClientHistoryList = useSelector(({ client }) => client.oldOrderHistory);

    const cartitemimpersonate = useSelector(
        ({ cart }) => cart.impersonateMember, shallowEqual
    );
    const [submitting, setSubmitting] = useState(false);
    const dispatch = useDispatch();
    const userEmailData = useSelector(({ user }) => user.loggedin_user);//RK--Changed from Verified_Email to loggedin_user
    const userMemberIdData = useSelector(({ cart }) => cart.impersonateMember);
    const [profileuser, setProfileuser] = useState(userMemberIdData && userMemberIdData.userprofile ? userMemberIdData.userprofile.Email : userEmailData != null ? userEmailData.Username : "");//added missing logic for impersonate
    React.useEffect(() => {
        dispatch(getClientOrderHistory(userMemberIdData && userMemberIdData.memberId));
        dispatch(getOldOrderHistory(profileuser));
        dispatch(getBRMSKey(profileuser, userMemberIdData && userMemberIdData.memberId))
    }, []);

    const handleDataTableClick = () => {
    };

    const toggleDisplayOne = () => {
        setTableColumnWidth(tableOneColumnWidth);
        setAtiveDisplay(filterOne);
        setTableCategories(categoriesOne);
        setTableItems(tableItemsOne);
    };

    const toggleDisplayTwo = () => {
        setTableColumnWidth(tableTwoColumnWidth);
        setAtiveDisplay(filterTwo);
        setTableCategories(categoriesTwo);
        setTableItems(tableItemsTwo);
    };

    /*if (clientOrderHistoryList.length === 0 && oldClientHistoryList.length === 0) {
        return (<EmptyTableComponent message={"You do not have any order history"}/>);
    }*/


    const downloadData = (orderid, ordernumber) => {
        setSubmitting(true);
        let memberId = null;
        if (cartitemimpersonate) {
            memberId = cartitemimpersonate.memberId;
        }
        ClientServices.getOrderCertificateFile(orderid, memberId).then(response => {

            if (response.FileContents) {
                //printData(response.FileContents, response.ContentType);
                const arrayBuffer = base64ToArrayBuffer(response.FileContents);
                createAndDownloadBlobFile(arrayBuffer, 'OrderReceipt-' + ordernumber);
            }
        });
        setSubmitting(false);
    }

    function base64ToArrayBuffer(base64) {
        const binaryString = window.atob(base64); // Comment this if not using base64
        const bytes = new Uint8Array(binaryString.length);
        return bytes.map((byte, i) => binaryString.charCodeAt(i));
    }

    function createAndDownloadBlobFile(body, filename, extension = 'pdf') {
        const blob = new Blob([body]);
        const fileName = `${filename}.${extension}`;
        if (navigator.msSaveBlob) {
            // IE 10+
            navigator.msSaveBlob(blob, fileName);
        } else {
            const link = document.createElement('a');
            // Browsers that support HTML5 download attribute
            if (link.download !== undefined) {
                const url = URL.createObjectURL(blob);
                link.setAttribute('href', url);
                link.setAttribute('download', fileName);
                link.style.visibility = 'hidden';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        }
    }

    const onDownloadOldFileCertificate = (shoppingCartID) => {
        ClientServices.downloadOldDataCertificate(shoppingCartID).then(response => {
            // console.log("---- Old certificate log");
            // console.log(response);
            if (response.FileContents) {
                // console.log("getting in");
                const arrayBuffer = base64ToArrayBuffer(response.FileContents);
                createAndDownloadBlobFile(arrayBuffer, 'OrderReceipt - ' + shoppingCartID);
            }
        })
    };

    return (
        <div className="order-data-table">
            <div className="trinity-container">

                <h2 className="d-lg-none">{title}</h2>
                <div className="section-filters mt-3 mb-3">
                    <span
                        className={`filter clickable
                            ${activeDisplay === filterOne ? "bold" : ""}
                        `}
                        onClick={toggleDisplayOne}
                    >
                        {filterOne}
                    </span>

                    {/* Comment this out for now, second filter button */}

                    <span className="seperator ml-2 mr-2">|</span>

                    <span
                        className={`filter clickable
                            ${activeDisplay === filterTwo ? "bold" : ""}
                        `}
                        onClick={toggleDisplayTwo}
                    >
                        {filterTwo}
                    </span>
                </div>
            </div>

            <div className="order-table-container">
                <div className="overflow-width-setter">
                    <div className="table-categories mb-3">
                        <div className="trinity-container d-flex fluid">
                            {tableCategories.map((category) => (
                                <h5
                                    key={category}
                                    style={{ width: tableColumnWidth }}
                                    className="category column m-0"
                                >
                                    <span className="mr-2">{category}</span>
                                </h5>
                            ))}
                        </div>
                    </div>

                    {activeDisplay === filterOne && clientOrderHistoryList && (
                        <div className="trinity-container">
                            <div className="table-items">
                                {
                                    clientOrderHistoryList.length === 0
                                        ? <h3>No Records Available.</h3>
                                        : clientOrderHistoryList.map((item, i) => {
                                            return (
                                                <>
                                                    <div key={Math.random() * 100 + i} className="table-item">
                                                        <div key={Math.random()} id={Math.random()}
                                                            style={{ width: tableColumnWidth }} className="column"
                                                            onClick={handleDataTableClick}>
                                                            {item.OrderNumber}
                                                        </div>

                                                        <div key={Math.random()} id={Math.random()}
                                                            style={{ width: tableColumnWidth }} className="column"
                                                            onClick={handleDataTableClick}>
                                                            {item.OrderDate}
                                                        </div>

                                                        <div key={Math.random()} id={Math.random()}
                                                            style={{ width: tableColumnWidth }} className="column"
                                                            onClick={handleDataTableClick}>
                                                            {/* {item.OrderTotal.toFixed(2)} */}
                                                            <>
                                                                <NumberFormat
                                                                    value={item.OrderTotal}
                                                                    displayType={"text"}
                                                                    thousandSeparator={true}
                                                                    prefix={"$"}
                                                                    decimalScale={2}
                                                                    fixedDecimalScale={true}
                                                                />
                                                            </>
                                                        </div>

                                                        <div key={Math.random()} id={Math.random()}
                                                            style={{ width: tableColumnWidth }} className="column"
                                                            onClick={handleDataTableClick}>
                                                            {item.PaymentStatus}
                                                        </div>

                                                        <div key={Math.random()} id={Math.random()}
                                                            style={{ width: tableColumnWidth }} className="column"
                                                            onClick={handleDataTableClick}>
                                                            {item.OrderStatusName}
                                                        </div>

                                                        <div className="column">
                                                            <CustomButton loading={submitting}
                                                                onClick={() => downloadData(item.OrderID, item.OrderNumber)}>Download</CustomButton>
                                                        </div>
                                                    </div>
                                                </>
                                            );
                                        }
                                        )
                                }
                            </div>
                        </div>
                    )}


                    {activeDisplay === filterTwo && oldClientHistoryList && (
                        <div className="trinity-container">
                            <div className="table-items">
                                {
                                    oldClientHistoryList.length === 0
                                        ? <h3>No Records Available.</h3>
                                        : oldClientHistoryList.map((item, i) => {
                                            return (
                                                <>
                                                    <div key={Math.random() * 100 + i} className="table-item">
                                                        <div key={Math.random()} id={Math.random()}
                                                            style={{ width: tableColumnWidth }} className="column"
                                                            onClick={handleDataTableClick}>
                                                            {item.OrderDate}
                                                        </div>

                                                        <div key={Math.random()} id={Math.random()}
                                                            style={{ width: tableColumnWidth }} className="column"
                                                            onClick={handleDataTableClick}>
                                                            {item.ShoppingCartId}
                                                        </div>

                                                        <div key={Math.random()} id={Math.random()}
                                                            style={{ width: tableColumnWidth }} className="column"
                                                            onClick={handleDataTableClick}>
                                                            <>
                                                                <NumberFormat
                                                                    value={item.Total}
                                                                    displayType={"text"}
                                                                    thousandSeparator={true}
                                                                    prefix={"$"}
                                                                    decimalScale={2}
                                                                    fixedDecimalScale={true}
                                                                />
                                                            </>
                                                        </div>

                                                        <div className="column">
                                                            <CustomButton loading={submitting}
                                                                onClick={() => onDownloadOldFileCertificate(item.ShoppingCartId)}>
                                                                Download
                                                            </CustomButton>
                                                        </div>
                                                    </div>
                                                </>
                                            );
                                        })}
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

export default OrderDataTable;
